// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import * as Setting from "../conf/Setting";
import FileSaver from "file-saver";

export function getOrganizations(owner, page = "", pageSize = "", field = "", value = "", sortField = "", sortOrder = "") {
  return fetch(`${Setting.ServerUrl}/api/get-organizations?owner=${owner}&p=${page}&pageSize=${pageSize}&field=${field}&value=${value}&sortField=${sortField}&sortOrder=${sortOrder}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getOrganization(owner, uid) {
  return fetch(`${Setting.ServerUrl}/api/get-organization?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function updateOrganization(owner, uid, organization) {
  const newOrganization = Setting.deepCopy(organization);
  return fetch(`${Setting.ServerUrl}/api/update-organization?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newOrganization),
  }).then(res => res.json());
}

export function addOrganization(organization) {
  const newOrganization = Setting.deepCopy(organization);
  return fetch(`${Setting.ServerUrl}/api/add-organization`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newOrganization),
  }).then(res => res.json());
}

export function deleteOrganization(organization) {
  const newOrganization = Setting.deepCopy(organization);
  return fetch(`${Setting.ServerUrl}/api/delete-organization`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newOrganization),
  }).then(res => res.json());
}

export function getDefaultApplication(owner, name) {
  return fetch(`${Setting.ServerUrl}/api/get-default-application?id=${owner}/${encodeURIComponent(name)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getDepartments(owner, organizationId, pid, pageSize = "", page = "") {
  return fetch(`${Setting.ServerUrl}/api/get-departments?owner=${owner}&organId=${organizationId}&pid=${pid}&pageSize=${pageSize}&p=${page}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getDepartment(uid) {
  return fetch(`${Setting.ServerUrl}/api/get-department?uid=${uid}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function addDepartment(department) {
  const newDepartment = Setting.deepCopy(department);
  return fetch(`${Setting.ServerUrl}/api/add-department`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newDepartment),
  }).then(res => res.json());
}

export function updateDepartment(uid, department) {
  const newDepartment = Setting.deepCopy(department);
  return fetch(`${Setting.ServerUrl}/api/update-department?uid=${uid}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newDepartment),
  }).then(res => res.json());
}

export function deleteDepartment(department) {
  const newDepartment = Setting.deepCopy(department);
  return fetch(`${Setting.ServerUrl}/api/delete-department`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newDepartment),
  }).then(res => res.json());
}

export function downloadDepartmentTemplate() {
  let fileName = "";
  return fetch(`${Setting.ServerUrl}/api/download-department-template`, {
    method: "GET",
    credentials: "include",
    responseType: "blob",
  }).then(res => {
    if (res.status === 404) {
      return;
    }
    // 获取响应头
    const fileNameEncode = res.headers
      .get("Content-Disposition")
      .split("filename*=utf-8''")[1];
    fileName = decodeURIComponent(fileNameEncode);
    return res.blob().then(blob => {
      FileSaver.saveAs(blob, fileName);
    });
  });
}

export function importDepartment(file) {
  const formData = new FormData();
  formData.append("import-department-file", file);
  return fetch(`${Setting.ServerUrl}/api/import-department`, {
    body: formData,
    method: "POST",
    credentials: "include",
  }).then(res => res.json());
}

export function downloadImportError(fileName) {
  return fetch(`${Setting.ServerUrl}/api/download-import-error?fileName=${fileName}`, {
    method: "GET",
    credentials: "include",
    responseType: "blob",
  }).then(res => {
    if (res.status === 404) {
      return;
    }
    // 获取响应头
    const fileNameEncode = res.headers
      .get("Content-Disposition")
      .split("filename*=utf-8''")[1];
    fileName = decodeURIComponent(fileNameEncode);
    return res.blob().then(blob => {
      FileSaver.saveAs(blob, fileName);
    });
  }).catch(error => {
    Setting.showResponseMessage(error);
  });
}

export function getNodes(owner, keyword) {
  return fetch(`${Setting.ServerUrl}/api/search-leaf-node?owner=${owner}&keyword=${keyword}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}
